import React from 'react';

import { Color } from 'types/colors';

import Images from './sprite-colored-icons.svg';

import css from './IconColored.module.scss';

// Colored icons are icons that have more than one fill in Figma. They can be any size and
// are generally used for illustrations.
//
// Adding or updating an icon:
// - Export svg from Figma to src/assets/sprite-colored-icons
//      - Use the component name from there, e.g. "Icon/airplane" => "airplane")
//      - Icons stored in that directory are used to generate the sprite, not referenced directly
// - Run `yarn make-colored-icon-sprite`. This generates sprite-colored-icons.svg.
// - Add icon name to ICONS_COLORED below
const ICONS_COLORED = [
    'avatar-female',
    'avatar-male',
    'error-cat',
    'illustration-people-jumping',
    'language-advanced-colored',
    'language-beginner-colored',
    'language-fluent-colored',
    'language-intermediate-colored',
    'language-native-colored',
    'location-pin-stroke-shadow',
    'man-woman',
    'people-talking',
    'person-large-female',
    'person-large-male',
] as const;

export type SpriteColorIcon = (typeof ICONS_COLORED)[number];

interface Props {
    name: (typeof ICONS_COLORED)[number];
    width: number;
    height?: number;
    color?: Color;
    className?: string;
}

const IconColored: React.FC<Props> = ({ name, width, height, color, className }) => {
    const rootVars = getComputedStyle(document.body);

    return (
        <div style={{ width: width, height: height ?? width }} className={className}>
            <svg
                className={css.icon}
                fill={color ? rootVars.getPropertyValue(`--${color}`) : undefined}
                width={width}
                height={height ?? width}
            >
                <use xlinkHref={`${Images}#${name}`} />
            </svg>
        </div>
    );
};

export { ICONS_COLORED };

export default React.memo(IconColored);
